import { CellTextAlignment, GridColumnType, GridFieldType, GridPageTarget, IGridColumn, IPageLink, Sort } from "../../../../base/models"
import { DisplayFormat, IDataSource, PageMode } from "../../../../base/types"
import { useEffect, useState } from "react";

import Accordion from "react-bootstrap/esm/Accordion";
import { EditPageLink } from "../../page-link";
import { EditTableLookup } from "../../table-lookup";
import { MUIIcon } from "../../../../widgets";
import { SelectAttribute } from "../../SelectAttribute"
import { SelectDisplayFormat } from "../../SelectDisplayFormat";

export const EditGridColumn = ({ dataSource, column, onChange, onCancel }: {
    dataSource?: IDataSource,
    column: IGridColumn,
    onChange: (column: IGridColumn) => void,
    onCancel: () => void,
}) => {
    const [localColumn, updateColumn] = useState<IGridColumn>(column);
    const initPageLink: IPageLink = { pageMode: PageMode.View }

    useEffect(() => {
        updateColumn(column)
        // eslint-disable-next-line
    }, [column])

    return (
        <div>
            <div className="d-flex flex-row gap-3">
                <div>
                    <div className="row g-2 gy-3 mb-2">
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Header</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, header: e.target.value })}
                                value={localColumn.header || ''}
                            />
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Field</label>
                            <SelectAttribute
                                attributes={dataSource?.attributes || []}
                                value={localColumn.field}
                                onChange={(field) => updateColumn({ ...localColumn, field })} />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Sequence</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, sequence: Number(e.target.value) })}
                                value={localColumn.sequence}
                            />
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Text Alignment</label>
                            <select
                                className="form-select form-select-sm"
                                onChange={(e) => updateColumn({ ...localColumn, alignment: e.target.value as CellTextAlignment })}
                                value={localColumn.alignment || CellTextAlignment.Default}
                            >
                                <option value={CellTextAlignment.Default}></option>
                                <option value={CellTextAlignment.Start}>Start</option>
                                <option value={CellTextAlignment.Center}>Center</option>
                                <option value={CellTextAlignment.End}>End</option>
                            </select>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">sort</label>
                            <select
                                className="form-select form-select-sm"
                                onChange={(e) => updateColumn({ ...localColumn, sort: e.target.value as Sort })}
                                value={localColumn.sort || Sort.Default}
                            >
                                <option value={Sort.Default}></option>
                                <option value={Sort.Ascending}>Ascending</option>
                                <option value={Sort.Descending}>Descending</option>
                            </select>
                        </div>
                    </div>
                    <div className="row g-2 gy-3 my-2">
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="form-check form-switch">
                                <label className="form-check-label" htmlFor="resizable">Resizable</label>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="resizable"
                                    name="resizable"
                                    onChange={(e) => updateColumn({ ...localColumn, resizable: e.target.checked })}
                                    checked={localColumn.resizable === true} />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="form-check form-switch">
                                <label className="form-check-label" htmlFor="resizable">Sortable</label>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="sortable"
                                    name="sortable"
                                    onChange={(e) => updateColumn({ ...localColumn, sortable: e.target.checked })}
                                    checked={localColumn.sortable === true} />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="form-check form-switch">
                                <label className="form-check-label" htmlFor="resizable">Filter</label>
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="filter"
                                    name="filter"
                                    onChange={(e) => updateColumn({ ...localColumn, filter: e.target.checked })}
                                    checked={localColumn.filter === true} />
                            </div>
                        </div>
                    </div>
                    <div className="row g-2 gy-3 my-2">
                        <div className="col-lg-2 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Width</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, width: Number(e.target.value) })}
                                value={localColumn.width}
                            />
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Min. Width</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, minWidth: Number(e.target.value) })}
                                value={localColumn.minWidth}
                            />
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Max. Width</label>
                            <input
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, maxWidth: Number(e.target.value) })}
                                value={localColumn.maxWidth}
                            />
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Header Class</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, headerClass: e.target.value })}
                                value={localColumn.headerClass || ''}
                            />
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Cell Class</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                onChange={(e) => updateColumn({ ...localColumn, cellClass: e.target.value })}
                                value={localColumn.cellClass || ''}
                            />
                        </div>
                    </div>
                    <div className="row g-2 gy-3 my-2">
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Data Type</label>
                            <select
                                className="form-select form-select-sm"
                                onChange={(e) => updateColumn({ ...localColumn, fieldType: e.target.value as GridFieldType })}
                                value={localColumn.fieldType || GridFieldType.Text}
                            >
                                <option value={GridFieldType.Text}>Text</option>
                                <option value={GridFieldType.Number}>Number</option>
                                <option value={GridFieldType.Boolean}>Boolean</option>
                                <option value={GridFieldType.Money}>Money</option>
                                <option value={GridFieldType.Date}>Date</option>
                                <option value={GridFieldType.Time}>Time</option>
                                <option value={GridFieldType.DateTime}>Datetime</option>
                                <option value={GridFieldType.Lookup}>Lookup</option>
                            </select>
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Display Format</label>
                            <SelectDisplayFormat
                                value={localColumn.displayFormat || DisplayFormat.Normal}
                                onChange={(value) => { updateColumn({ ...localColumn, displayFormat: value }) }} />
                        </div>

                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Column Type</label>
                            <select
                                className="form-select form-select-sm"
                                onChange={(e) => updateColumn({ ...localColumn, columnType: e.target.value as GridColumnType })}
                                value={localColumn.columnType || GridColumnType.Normal}
                            >
                                <option value={GridColumnType.Normal}></option>
                                <option value={GridColumnType.PageLink}>Page Link</option>
                                <option value={GridColumnType.DownloadLink}>Download Link</option>
                            </select>
                        </div>
                    </div>
                </div>
                {
                    (localColumn.fieldType === GridFieldType.Lookup || localColumn.columnType === GridColumnType.DownloadLink || localColumn.columnType === GridColumnType.PageLink) && <>
                        <div className="w-350px">
                            <Accordion className="accordion-sm accordion-primary" alwaysOpen>
                                {(localColumn.fieldType === GridFieldType.Lookup) && <>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Lookup Settings</Accordion.Header>
                                        <Accordion.Body>
                                            <EditTableLookup
                                                dataSource={dataSource}
                                                tableLookup={localColumn.lookup || {}}
                                                onChange={(value) => updateColumn({ ...localColumn, lookup: value })} />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </>}
                                {(localColumn.columnType === GridColumnType.DownloadLink) && <>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Download Link Settings</Accordion.Header>
                                        <Accordion.Body>
                                            <label className="form-label fs-7 fw-semibold">URL Field</label>
                                            <SelectAttribute
                                                attributes={dataSource?.attributes || []}
                                                value={localColumn.urlField}
                                                onChange={(urlField) => updateColumn({ ...localColumn, urlField })} />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </>}
                                {(localColumn.columnType === GridColumnType.PageLink) && <>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Page Link Settings</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="">
                                                <label className="form-label fs-7 fw-semibold">Page Target</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    onChange={(e) => updateColumn({ ...localColumn, pageTarget: e.target.value as GridPageTarget })}
                                                    value={localColumn.pageTarget || GridPageTarget.Redirect}
                                                >
                                                    <option value={GridPageTarget.Redirect}>Redirect</option>
                                                    <option value={GridPageTarget.NewTab}>New Tab</option>
                                                    <option value={GridPageTarget.Dialog}>Dialog</option>
                                                    <option value={GridPageTarget.Offcanvas}>Offcanvas</option>
                                                </select>
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-semibold">Page Link</label>
                                                <div className="border p-5">
                                                    <EditPageLink
                                                        dataSource={dataSource}
                                                        pageLink={localColumn.pageLink || initPageLink}
                                                        onChange={(value) => updateColumn({ ...localColumn, pageLink: value })} />
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </>
                                }
                            </Accordion>
                        </div>

                    </>
                }
            </div>

            <div className="my-3 text-end">
                <button
                    type="button"
                    onClick={() => onChange(localColumn)}
                    className="btn btn-primary btn-sm me-3 py-2">
                    <MUIIcon iconName={"SaveOutlined"} className="me-1" />
                    Save
                </button>
                <button
                    type="button"
                    onClick={onCancel}
                    className="btn btn-secondary btn-sm py-2">
                    <MUIIcon iconName={"CancelOutlined"} className="me-1" />
                    Cancel
                </button>
            </div>
        </div>
    )
}
